import {
  ROOM_SEARCH_STEPS_M,
  UNCALIBRATED_ROOM_SEARCH_STEPS_PT,
} from "../constants";
import type { GetRoomSearchStepsPt } from "./types";

export const getRoomSearchStepsPt: GetRoomSearchStepsPt = ({
  metersPerPdfPoint,
}) => {
  if (metersPerPdfPoint <= 0) return UNCALIBRATED_ROOM_SEARCH_STEPS_PT;
  return ROOM_SEARCH_STEPS_M.map((distanceM) => distanceM / metersPerPdfPoint);
};
